module.exports = __webpack_public_path__ + "img/web_iosxz_btn.a3a7a167.png";